import React, { Component } from "react";
import { AuthorizationCodeCallback } from "react-oauth2-auth-code-flow";
import {  bindActionCreators } from "redux";
import { connect } from "react-redux";
import {setProfileFromTnAccount} from "../components/header/header-actions";
import OauthClientFactory from "./OauthClientFactory";
import Spinner from "../components/spinner";
import Config from "./Config";

class ReceiveFromTnAccountContainer extends Component {
    handleSuccess = async (accessToken, { response, state }) => {
        this.props.setProfileFromTnAccount(accessToken, state.from);
    };

    handleError = () => {
        window.location.replace(`${Config.domain}${Config.prefixUrl}`);
    };

    render() {
        return (
            <AuthorizationCodeCallback
                oauthClient={OauthClientFactory.create()}
                onAuthSuccess={this.handleSuccess}
                onAuthError={this.handleError}
                render={() => (
                    <div className="spinner-container">
                        <Spinner loadingLabel='...' />
                    </div>
                )}
            />
        );
    }

}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, {setProfileFromTnAccount}), dispatch)
}


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReceiveFromTnAccountContainer);
